(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kelpeat-supply-chain"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initKsc(root){
    if(!root || root.dataset.kscReady) return;
    root.dataset.kscReady = '1';

    var cards    = Array.prototype.slice.call(root.querySelectorAll('.ksc-card'));       /* desktop text */
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.ksc-trigger'));    /* desktop + mobile */
    var shots    = Array.prototype.slice.call(root.querySelectorAll('.ksc-shot'));       /* desktop + mobile */
    var mtexts   = Array.prototype.slice.call(root.querySelectorAll('.ksc-mtext'));      /* mobile text */
    var num  = root.querySelector('[data-ksc-num]');
    var bar  = root.querySelector('[data-ksc-bar]');
    var mNum = root.querySelector('[data-ksc-mnum]');
    var mBar = root.querySelector('[data-ksc-mbar]');
    var railFill = root.querySelector('[data-ksc-railfill]');
    var rail = root.querySelector('[data-ksc-rail]');
    var total = cards.length;
    if(!total) return;
    var current = -1;

    function pad(n){ return (n<10?'0':'') + n; }

    function setActive(i){
      if(i === current) return;
      current = i;
      var label = pad(i+1);
      var w = ((i+1)/total*100) + '%';

      /* Match by data attribute — shots & triggers are duplicated across the
         desktop and mobile layouts, so array index != stage index. */
      cards.forEach(function(c){ var s=+c.getAttribute('data-ksc-stage');
        c.classList.toggle('is-active', s===i); c.classList.toggle('is-done', s<i); });
      shots.forEach(function(sh){ var s=+sh.getAttribute('data-ksc-shot'); var on=s===i;
        sh.classList.toggle('is-active', on); sh.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      mtexts.forEach(function(t){ var s=+t.getAttribute('data-ksc-mtext');
        t.classList.toggle('is-active', s===i); });

      if(num)  num.textContent  = label;   if(bar)  bar.style.width  = w;
      if(mNum) mNum.textContent = label;   if(mBar) mBar.style.width = w;

      /* Rail fill (desktop only — skip when the timeline is hidden) */
      if(railFill && rail){
        var ac = null;
        for(var k=0;k<cards.length;k++){ if(+cards[k].getAttribute('data-ksc-stage')===i){ ac=cards[k]; break; } }
        var node = ac ? ac.querySelector('.ksc-card__node') : null;
        if(node && node.offsetParent !== null){
          var railTop = rail.getBoundingClientRect().top;
          var mid = node.getBoundingClientRect().top - railTop + node.offsetHeight/2 - 26;
          railFill.style.height = Math.max(0, mid) + 'px';
        }
      }
    }

    /* Compute the active stage from geometry on every scroll frame. This is
       skip-proof: a fast scroll can't "jump over" a stage the way a thin
       IntersectionObserver band can. The active trigger is the one straddling
       the viewport centre (or nearest to it). */
    var ticking = false;
    function updateActive(){
      ticking = false;
      var mid = window.innerHeight * 0.5;
      var bestStage = null, bestDist = Infinity, straddled = false;
      for(var idx=0; idx<triggers.length; idx++){
        var t = triggers[idx], r = t.getBoundingClientRect();
        if(r.height === 0) continue;                 /* hidden layout's triggers */
        var st = +t.getAttribute('data-ksc-stagewrap');
        if(r.top <= mid && r.bottom >= mid){ bestStage = st; straddled = true; break; }
        if(!straddled){
          var d = Math.min(Math.abs(r.top - mid), Math.abs(r.bottom - mid));
          if(d < bestDist){ bestDist = d; bestStage = st; }
        }
      }
      if(bestStage !== null) setActive(bestStage);
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(updateActive); } }
    window.addEventListener('scroll', onScroll, { passive:true });

    cards.forEach(function(c){
      c.addEventListener('click', function(){
        var i = +c.getAttribute('data-ksc-stage');
        setActive(i);                       /* instant visual feedback */
        if(triggers[i]) triggers[i].scrollIntoView({ behavior:'smooth', block:'center' });
      });
    });

    setActive(0);
    window.addEventListener('resize', function(){ current = -1; updateActive(); });
    updateActive();
  }

  function boot(ctx){ (ctx||document).querySelectorAll('[data-ksc]').forEach(initKsc); }
  if(document.readyState !== 'loading'){ boot(); }
  else { document.addEventListener('DOMContentLoaded', function(){ boot(); }); }
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
